import React, { createContext } from "react";
import usePersistLocal from "../hooks/usePersistLocal";
import rootReducer from "../Reducers";
export const initialState = { bookmark: {}, menu: {} };

export const StoreContext = createContext({
  state: initialState,
  dispatch: () => {},
});

export const StoreProvider = ({ children }) => {
  const [state, dispatch] = usePersistLocal(
    "BIN_WISE",
    rootReducer,
    initialState,
    ["menu"]
  );

  return (
    <StoreContext.Provider value={{ state, dispatch }}>
      {children}
    </StoreContext.Provider>
  );
};

export default StoreProvider;
